import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.tr<{ showRowBorder?: boolean; highlightHoveredRow?: boolean }>(props => ({
    ...(props.showRowBorder && {
        borderTop: theme(props).border.solid,

        ":first-of-type": {
            borderTop: 0,
        },
    }),
    ...(props.highlightHoveredRow && {
        "&:hover": {
            backgroundColor: theme(props).keyPalette.panelBackgroundColor,
            cursor: "pointer",
        },
    }),
}));
